/**
*
* Payments
*
*/

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Card } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { useApi2 } from 'containers/Api2/index.js';
import InfiniteScroll from 'components/interaction/InfiniteScroll/index.jsx';
import { idValues } from 'utils/arrays.js';
import checkEntity from 'utils/checkEntity.jsx';
import { useSearch } from 'utils/urlUtils.js';
import { intlBreak } from 'utils/intlFunctions.jsx';
import messages from './messages.js';
import AccountModal from './AccountModal.jsx';
import AccountStatus from './AccountStatus.jsx';

const newAccount = { iban: '', name: '', currency: 'EUR' };

function Payments(props) {
  const { setMeta } = props;
  const { bankAccountId } = useSearch();
  const [editAccount, setEditAccount] = useState(null);
  const accounts = useApi2({ url: 'sa/bankaccounts?offset=0&limit=10', version: 2, ignore: [404] });
  const { loading, hasMore, loadMore } = accounts;
  useEffect(() => {
    setMeta({
      title: messages.paymentModule,
      pageTitle: messages.paymentModule,
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Card>
      <Card.Header className="d-flex justify-content-between align-items-baseline border-0">
        <h3><FormattedMessage {...messages.header} /></h3>
        <Button variant="primary" onClick={() => setEditAccount(newAccount)}><FormattedMessage {...messages.addAccount} /></Button>
      </Card.Header>
      <Card.Body>
        <p className="text-help mb-5"><FormattedMessage {...messages.helpAccounts} values={intlBreak} /></p>
        {checkEntity(accounts, messages.noAccounts) || (
          <InfiniteScroll
            hasMore={hasMore}
            loadMore={loadMore}
            loading={loading}
          >
            {idValues(accounts).map((account) => <AccountStatus key={account.id} account={account} active={account.id === bankAccountId} />)}
          </InfiniteScroll>

        )}
        <AccountModal show={Boolean(editAccount)} account={editAccount} onHide={() => setEditAccount(null)} />
      </Card.Body>
    </Card>
  );
}

Payments.propTypes = {
  setMeta: PropTypes.func,
};

export default Payments;
